import { useState } from "react";
import { useAuth } from "../_providers/AuthProvider";
import Widget from "../_components/Widget";

const LoginForm = () => {
    const auth = useAuth();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async () => {
        await auth.logIn(email, password)
        .then(() => {
            setEmail("");
            setPassword("");

        }).catch((error) => {
            setError(error.message);
        });
    }

    return (
        <Widget title="Sign In" flex={1} maxWidth="450px">
            <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            {error ? <p>{error}</p> : null}
            <p style={{color: "#257de1", fontSize: 13, cursor: "pointer"}}>Forgot password?</p>
            <button className="btn" style={{width: "100%"}} onClick={handleLogin}><p style={{textAlign: "center", width: "100%"}}>Sign In</p></button>
        </Widget>
    )
}

const SignUpForm = () => {
    const auth = useAuth();

    const [email, setEmail] = useState("");
    const [displayName, setDisplayName] = useState("");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    const handleSignUp = async () => {
        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        if (displayName.length < 3) {
            setError("Display name is to short")
            return;
        }
        await auth.signUp(email, displayName, password)
        .then(() => {
            setEmail("");
            setDisplayName("")
            setPassword("");
            setConfirmPassword("");
        }).catch((error) => {
            setError(error.message);
        });
    }

    return (
        <Widget title="Sign Up" flex={1} maxWidth="450px">
            <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <input 
                type="text"
                placeholder="Display name"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
            />
            <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <input
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {error ? <p>{error}</p> : null}
            <button className="btn" style={{width: "100%"}} onClick={handleSignUp}><p style={{textAlign: "center", width: "100%"}}>Sign Up</p></button>
        </Widget>
    )
}

export const AuthPage = () => {
    return (
        <div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: 150}}>
            <h1 style={{width: "100%", textAlign: "center", marginBottom: 0}}>EasyFin</h1>
            <h2 style={{width: "100%", textAlign: "center", fontWeight: "400", marginTop: 0}}>A Floren app</h2>
            </div>
            <div style={{ display: "flex", flexDirection: "row", gap: 20, justifyContent: "center", flexWrap: "wrap" }}>
            <LoginForm />
            <SignUpForm />
            </div>
        </div>
    )
}